import React from "react";
import { FaArrowUp } from "react-icons/fa";

const transactions = [
  {
    title: "Todays Volume",
    amount: "142.5 VTSG",
    change: "8.3%",
    direction: "up"
  },
  {
    title: "Todays Volume",
    amount: "142.5 VTSG",
    change: "8.3%",
    direction: "up"
  }
];

const TransactionMonitor = () => {
  return (
    <div className="w-full bg-white shadow-md rounded-xl p-6 font-poppins">
      <div className="pr-10">
        <h2 className="font-poppins font-semibold text-20 leading-5 text-black mb-4">
          Monitor Ecosystem Transactions
        </h2>
        <p className="font-poppins font-normal text-16 leading-2 text-[#656565] mb-8">
          Track and manage all transactions within the Ventursa Gold ecosystem.
        </p>

        <div className="flex flex-col gap-3 mb-6">
          {transactions.map((txn, idx) => (
            <div
              key={idx}
              className="flex justify-between items-center shadow-lg  rounded-lg px-4 py-3"
            >
              <div>
                <p className="font-poppins font-medium text-16 text-black leading-4 pb-3">
                  {txn.title}
                </p>
                <p className="text-14 font-poppins leading-3 text-[#656565]">
                  {txn.amount}
                </p>
              </div>
              <div className="flex items-center gap-1 text-green-600 font-semibold text-sm">
                <FaArrowUp className="text-sm" />
                {txn.change}
              </div>
            </div>
          ))}
        </div>

        <button className="w-9/12 bg-[#54A5F5]  text-white  py-4 font-poppins font-medium text-16 leading-4 px-4 rounded-md transition">
          View Transaction Dashboard
        </button>
      </div>
    </div>
  );
};

export default TransactionMonitor;
